import React, { useRef } from 'react';
import { toast } from 'react-toastify';
import { Link, useHistory } from 'react-router-dom';
import { useMutation } from 'react-query';
import { Card, Form, Row, Col } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import {
    LOGIN_SSO_ORIGIN_KEY,
    messageError,
    status200,
    status400,
    messageToast,
    typeError
} from '../../utils/define';
import { URI_INTERNAL } from '../../utils/pathLocations';
import { AUTH_API } from '../../utils/apiUrl.js';
import { Post } from '../../utils/httpProvider';
import Cookies from 'js-cookie';

const SPECIAL_CHAR_REGEX = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~]/;

const RecoverPassword = () => {
    // const passwordInput = useRef(null);
    // const confirmPasswordInput = useRef(null);
    const [t] = useTranslation();
    const history = useHistory();

    document.getElementById('root').classList = 'hold-transition login-page';

    const addMutation = useMutation((value) =>
        Post(AUTH_API.RESET_PASSWORD, null, value, false, true)
    );

    const getLoginSsoUrl = () => {
        const origin =
            Cookies.get(LOGIN_SSO_ORIGIN_KEY) || window.location.origin;

        return `${origin}${URI_INTERNAL.LOGIN_SSO_PATH}`;
    };

    const handlePost = async (values, actions) => {
        addMutation.mutate(values, {
            onSuccess: async (respone) => {
                try {
                    if (respone.status === status200) {
                        toast.success(
                            messageToast.messageToastRecoverPassSuccess
                        );
                        window.location.href =
                            getLoginSsoUrl();
                    }
                    if (respone.status === status400) {
                        const result = await respone.json();
                        if (result.type) {
                            if (result.type === typeError.UserName) {
                                actions.setErrors({
                                    UserName: result.errors
                                        ? result.errors.content[0]
                                        : ''
                                });
                            }
                            if (result.type === typeError.Code) {
                                actions.setErrors({
                                    code: result.errors
                                        ? result.errors.content[0]
                                        : ''
                                });
                            }
                        }
                    }
                } catch (error) {
                    toast.error(messageToast.messageToastTryCatch);
                }
            },
            onError: (error) => { 
                console.log(error);
                toast.error(messageToast.messageToastTryCatch);
            }
        });
    };

    const schema = yup.object().shape({
        username: yup
            .string()
            .trim()
            .required(messageError.emptyMessage)
            .matches(/^\d{12}$/, 'Tên đăng nhập phải là căn cước công dân gồm đúng 12 chữ số'),
        code: yup.string().required(messageError.emptyMessage),
        password: yup
            .string()
            .min(8, messageError.minLength8Message)
            .max(30, messageError.maxLength30Message)
            // .matches(/[A-Z]/, messageError.passwordUppercase)
            // .matches(/[0-9]/, messageError.passwordNumber)
            // .matches(SPECIAL_CHAR_REGEX, messageError.passwordSpecial)
            .required(messageError.emptyMessage),
        confirmPassword: yup
            .string()
            .oneOf([yup.ref('password'), null], messageError.likePassword)
            .required(messageError.emptyMessage)
    });

    return (
        <div className="login-box">
            <div className="card card-outline card-primary">
                <div className="card-header text-center">
                    <Link to="/" className="h1">
                        <b>Bệnh viện TWQĐ 108</b>
                    </Link>
                </div>
                <div className="card-body">
                    <p className="login-box-msg">
                        Bạn chỉ còn 1 bước nữa để lấy lại mật khẩu, hãy tiếp tục
                    </p>
                    <Formik
                        validationSchema={schema}
                        onSubmit={(values, actions) =>
                            handlePost(values, actions)
                        }
                        initialValues={{
                            username: '',
                            code: '',
                            password: '',
                            confirmPassword: ''
                        }}
                    >
                        {({ handleSubmit, handleChange, values, errors }) => (
                            <Form onSubmit={handleSubmit} autoComplete="off">
                                <Form.Label>Tên đăng nhập</Form.Label>
                                <div className="input-group mb-3">
                                    <Form.Control
                                        placeholder="Tên đăng nhập"
                                        type="text"
                                        name="username"
                                        autoComplete="off"
                                        value={values.username}
                                        onChange={handleChange}
                                        isInvalid={!!errors.username}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.username}
                                    </Form.Control.Feedback>
                                </div>
                                <Form.Label>Mã xác thực</Form.Label>
                                <div className="input-group mb-3">
                                    <Form.Control
                                        placeholder="Mã xác thực"
                                        type="text"
                                        name="code"
                                        autoComplete="off"
                                        inputMode="numeric"
                                        value={values.code}
                                        onChange={handleChange}
                                        isInvalid={!!errors.code}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.code}
                                    </Form.Control.Feedback>
                                </div>
                                <Form.Label>Mật khẩu mới</Form.Label>
                                <div className="input-group mb-3">
                                    <Form.Control
                                        type="password"
                                        placeholder="Mật khẩu"
                                        name="password"
                                        autoComplete="new-password"
                                        value={values.password}
                                        onChange={handleChange}
                                        isInvalid={!!errors.password}
                                    />

                                    <Form.Control.Feedback type="invalid">
                                        {errors.password}
                                    </Form.Control.Feedback>
                                </div>
                                <Form.Label>Xác nhận mật khẩu</Form.Label>
                                <div className="input-group mb-3">
                                    <Form.Control
                                        type="password"
                                        placeholder="Xác nhận mật khẩu"
                                        name="confirmPassword"
                                        autoComplete="new-password"
                                        value={values.confirmPassword}
                                        onChange={handleChange}
                                        isInvalid={!!errors.confirmPassword}
                                    />

                                    <Form.Control.Feedback type="invalid">
                                        {errors.confirmPassword}
                                    </Form.Control.Feedback>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <button
                                            type="submit"
                                            className="btn btn-primary btn-block"
                                        >
                                            Xác nhận
                                        </button>
                                    </div>
                                </div>
                            </Form>
                        )}
                    </Formik>
                    <p className="mt-3 mb-1" style={{ textAlign: 'center' }}>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => {
                                window.location.href =
                                    getLoginSsoUrl();
                            }}
                        >
                            Đến trang đăng nhập SSO
                        </button>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default RecoverPassword;
